/** @format */

import { message } from "antd";
import axios from "axios";
import { call, fork, put, takeLatest } from "redux-saga/effects";
import { BASE_URL } from "../../utils/apiConfig";
import { setGlobalLoading } from "../slices/globalDataSlice";
import { setUserData } from "../slices/userSlice";

const loginUser = async (username, password, is_client) => {
  let payload = {
    password: password,
    email: username,
    is_client: is_client ?? false,
  };
  if (localStorage.getItem("map_token")) {
    payload["map_token"] = localStorage.getItem("map_token");
  }
  const response = await axios.post("/login/", payload, {
    headers: {
      Authorization: "",
    },
  });
  if (response.status === 200) {
    localStorage.setItem("token", response.data.access_token);
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${response.data.access_token}`;

    return response.data.access_token;
  } else {
    return false;
  }
};
const fetchUserData = async () => {
  const response = await axios.get(`${BASE_URL}current-user/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.status === 200) {
    localStorage.setItem("userDetails", JSON.stringify(response.data));
    let userDetails = {
      ...response?.data,
      school_data: response.data?.school_data[0],
      school_data_list: response.data?.school_data,
      token: localStorage.getItem("token"),
      authorized: true,
    };
    return userDetails;
  } else {
    return false;
  }
};

function* userLogin({ payload }) {
  const { username, password, is_client } = payload;
  yield put(setGlobalLoading(true));
  try {
    const userToken = yield call(loginUser, username, password, is_client);
    if (userToken) {
      let payload = { token: userToken, authorized: true };
      yield put(setUserData(payload));
      yield fork(GetCurrentUserData);
    } else {
    }
  } catch (e) {
    message.error(e?.response?.data?.message ?? "Login Failed");
  } finally {
    yield put(setGlobalLoading(false));
  }
}
function* userLogOut() {
  yield put(setGlobalLoading(true));
  localStorage.clear();
  sessionStorage.clear();
  yield put(setUserData({}));
  window.location.replace("/auth/login");
  yield put(setGlobalLoading(false));
}
function* GetCurrentUserData() {
  yield put(setGlobalLoading(true));
  localStorage.removeItem("email");
  try {
    const userData = yield call(fetchUserData);

    if (userData) {
      yield put(setUserData(userData));
    } else {
      message.error("wrong Credentials1");
    }
  } catch (e) {
    console.log("Login failed");
  } finally {
    yield put(setGlobalLoading(false));
  }
}

function* userSaga() {
  yield takeLatest("USER_LOGIN", userLogin);
  yield takeLatest("USER_LOGOUT", userLogOut);
  yield takeLatest("GET_USER_DATA", GetCurrentUserData);
  yield call(GetCurrentUserData); // run once on app load to check user auth
}
export default userSaga;
